import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { FontSize } from "../utils/types";
import { fontSizeMapping } from "../utils/mappings";

export function EmptyPanel({
  widthClass = "w-[830px]",
  children,
}: {
  widthClass?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="tw-boundary">
      <div
        className={`rounded-[10px] p-6 ${widthClass}`}
        style={{ boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.12)" }}
      >
        {children}
      </div>
    </div>
  );
}

export function ExpandablePanel({
  title,
  titleFontSize,
  children,
  widthClass = "w-[830px]",
}: {
  title: string;
  titleFontSize: FontSize;
  children?: React.ReactNode;
  widthClass?: string;
}) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <EmptyPanel widthClass={widthClass}>
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className={`font-bold ${fontSizeMapping[titleFontSize]} text-neutral-900`}>
            {title}
          </div>
        </div>
        <div onClick={() => setIsExpanded(!isExpanded)} className="cursor-pointer">
          {isExpanded ? (
            <ChevronUpIcon className="h-6 w-6" />
          ) : (
            <ChevronDownIcon className="h-6 w-6" />
          )}
        </div>
      </div>
      {isExpanded && children}
    </EmptyPanel>
  );
}
